import TradingSectionClient from "./TradingSectionClient";
import { TabItem, TradingSectionProps } from "./types";

export const TradingSectionTabs: React.FC<TradingSectionProps> = ({
  content,
}) => {
  return (
    <TradingSectionClient
      tabs={Object.values(content?.tabs?.[0] || {}) as TabItem[]}
    />
  );
};
